import actionTypes from './actionTypes';

const INITIAL_STATE = {
  discountCodesLoading: false,
  discountCodesFailed: false,
  discountCodesError: false,
  discountCodesMessage: null,
  discountCodes: {},
  discountCodesList: [],

  discountCodeDetailsLoading: false,
  discountCodeDetailsFailed: false,
  discountCodeDetailsError: false,
  discountCodeDetailsMessage: null,
  discountCodeDetails: {},


  insertNewDiscountCodeLoading: false,
  insertNewDiscountCodeFailed: false,
  insertNewDiscountCodeError: false,
  insertNewDiscountCodeMessage: null,

  updateDiscountCodeLoading: false,
  updateDiscountCodeFailed: false,
  updateDiscountCodeError: false,
  updateDiscountCodeMessage: null,

  updateDiscountCodeStatusLoading: false,
  updateDiscountCodeStatusFailed: false,
  updateDiscountCodeStatusError: false,
  updateDiscountCodeStatusMessage: null,


  createRandomCodeLoading: false,
  createRandomCodeFailed: false,
  createRandomCodeError: false,
  createRandomCodeMessage: null,
  randomCode: {},



  searchedSpecialUsersLoading: false,
  searchedSpecialUsersFailed: false,
  searchedSpecialUsersError: false,
  searchedSpecialUsersMessage: null,
  searchedSpecialUsers: {},
  searchedSpecialUsersList: [],


  discountCodeUsersLoading: false,
  discountCodeUsersFailed: false,
  discountCodeUsersError: false,
  discountCodeUsersMessage: null,
  discountCodeUsers: {},
  discountCodeUsersList: [],


}


export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ALL_DISCOUNT_CODES_LOADING: {
      return {
        ...state,
        discountCodesLoading: true,
        discountCodesFailed: false,
        discountCodesError: false,
        discountCodesMessage: null,
        discountCodes: {},
        discountCodesList: [],




        searchedSpecialUsersLoading: false,
        searchedSpecialUsersFailed: false,
        searchedSpecialUsersError: false,
        searchedSpecialUsersMessage: null,
        searchedSpecialUsers: {},
        searchedSpecialUsersList: [],

      };
    };
    case actionTypes.FETCH_ALL_DISCOUNT_CODES_REJECT: {
      return {
        ...state,
        discountCodesLoading: false,
        discountCodesFailed: false,
        discountCodesError: true,
        discountCodesMessage: null,
        discountCodes: {},
        discountCodesList: [],



        searchedSpecialUsersLoading: false,
        searchedSpecialUsersFailed: false,
        searchedSpecialUsersError: false,
        searchedSpecialUsersMessage: null,
        searchedSpecialUsers: {},
        searchedSpecialUsersList: [],

      };
    };
    case actionTypes.FETCH_ALL_DISCOUNT_CODES_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        discountCodesLoading: false,
        discountCodesFailed: true,
        discountCodesError: false,
        discountCodesMessage: message,
        discountCodes: {},
        discountCodesList: [],



        searchedSpecialUsersLoading: false,
        searchedSpecialUsersFailed: false,
        searchedSpecialUsersError: false,
        searchedSpecialUsersMessage: null,
        searchedSpecialUsers: {},
        searchedSpecialUsersList: [],

      };
    };
    case actionTypes.FETCH_ALL_DISCOUNT_CODES_SUCCESS: {
      return {
        ...state,
        discountCodesLoading: false,
        discountCodesFailed: false,
        discountCodesError: false,
        discountCodesMessage: null,
        discountCodes: { ...action.payload },
        discountCodesList: [...action.payload.discountCodes],



        searchedSpecialUsersLoading: false,
        searchedSpecialUsersFailed: false,
        searchedSpecialUsersError: false,
        searchedSpecialUsersMessage: null,
        searchedSpecialUsers: {},
        searchedSpecialUsersList: [],

      };
    };



    case actionTypes.FETCH_DISCOUNT_CODE_BY_ID_LOADING: {
      return {
        ...state,
        discountCodeDetailsLoading: true,
        discountCodeDetailsFailed: false,
        discountCodeDetailsError: false,
        discountCodeDetailsMessage: null,
        discountCodeDetails: {},
      };
    };
    case actionTypes.FETCH_DISCOUNT_CODE_BY_ID_REJECT: {
      return {
        ...state,
        discountCodeDetailsLoading: false,
        discountCodeDetailsFailed: false,
        discountCodeDetailsError: true,
        discountCodeDetailsMessage: null,
        discountCodeDetails: {},
      };
    };
    case actionTypes.FETCH_DISCOUNT_CODE_BY_ID_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        discountCodeDetailsLoading: false,
        discountCodeDetailsFailed: true,
        discountCodeDetailsError: false,
        discountCodeDetailsMessage: message,
        discountCodeDetails: {},
      };
    };
    case actionTypes.FETCH_DISCOUNT_CODE_BY_ID_SUCCESS: {
      return {
        ...state,
        discountCodeDetailsLoading: false,
        discountCodeDetailsFailed: false,
        discountCodeDetailsError: false,
        discountCodeDetailsMessage: null,
        discountCodeDetails: { ...action.payload },
      };
    };





    case actionTypes.INSERT_NEW_DISCOUNT_CODE_LOADING: {
      return {
        ...state,
        insertNewDiscountCodeLoading: true,
        insertNewDiscountCodeFailed: false,
        insertNewDiscountCodeError: false,
        insertNewDiscountCodeMessage: null,
      };
    };
    case actionTypes.INSERT_NEW_DISCOUNT_CODE_REJECT: {
      return {
        ...state,
        insertNewDiscountCodeLoading: false,
        insertNewDiscountCodeFailed: false,
        insertNewDiscountCodeError: true,
        insertNewDiscountCodeMessage: null,
      };
    };
    case actionTypes.INSERT_NEW_DISCOUNT_CODE_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        insertNewDiscountCodeLoading: false,
        insertNewDiscountCodeFailed: true,
        insertNewDiscountCodeError: false,
        insertNewDiscountCodeMessage: message,
      };
    };
    case actionTypes.INSERT_NEW_DISCOUNT_CODE_SUCCESS: {
      return {
        ...state,
        insertNewDiscountCodeLoading: false,
        insertNewDiscountCodeFailed: false,
        insertNewDiscountCodeError: false,
        insertNewDiscountCodeMessage: null,
      };
    };




    case actionTypes.UPDATE_DISCOUNT_CODE_LOADING: {
      return {
        ...state,
        updateDiscountCodeLoading: true,
        updateDiscountCodeFailed: false,
        updateDiscountCodeError: false,
        updateDiscountCodeMessage: null,
      };
    };
    case actionTypes.UPDATE_DISCOUNT_CODE_REJECT: {
      return {
        ...state,
        updateDiscountCodeLoading: false,
        updateDiscountCodeFailed: false,
        updateDiscountCodeError: true,
        updateDiscountCodeMessage: null,
      };
    };
    case actionTypes.UPDATE_DISCOUNT_CODE_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        updateDiscountCodeLoading: false,
        updateDiscountCodeFailed: true,
        updateDiscountCodeError: false,
        updateDiscountCodeMessage: message,
      };
    };
    case actionTypes.UPDATE_DISCOUNT_CODE_SUCCESS: {
      return {
        ...state,
        updateDiscountCodeLoading: false,
        updateDiscountCodeFailed: false,
        updateDiscountCodeError: false,
        updateDiscountCodeMessage: null,
      };
    };




    case actionTypes.UPDATE_DISCOUNT_CODE_STATUS_LOADING: {
      return {
        ...state,
        updateDiscountCodeStatusLoading: true,
        updateDiscountCodeStatusFailed: false,
        updateDiscountCodeStatusError: false,
        updateDiscountCodeStatusMessage: null,
      };
    };
    case actionTypes.UPDATE_DISCOUNT_CODE_STATUS_REJECT: {
      return {
        ...state,
        updateDiscountCodeStatusLoading: false,
        updateDiscountCodeStatusFailed: false,
        updateDiscountCodeStatusError: true,
        updateDiscountCodeStatusMessage: null,
      };
    };
    case actionTypes.UPDATE_DISCOUNT_CODE_STATUS_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        updateDiscountCodeStatusLoading: false,
        updateDiscountCodeStatusFailed: true,
        updateDiscountCodeStatusError: false,
        updateDiscountCodeStatusMessage: message,
      };
    };
    case actionTypes.UPDATE_DISCOUNT_CODE_STATUS_SUCCESS: {
      return {
        ...state,
        updateDiscountCodeStatusLoading: false,
        updateDiscountCodeStatusFailed: false,
        updateDiscountCodeStatusError: false,
        updateDiscountCodeStatusMessage: null,
      };
    };







    case actionTypes.CREATE_RANDOM_DISCOUNT_CODE_LOADING: {
      return {
        ...state,
        createRandomCodeLoading: true,
        createRandomCodeFailed: false,
        createRandomCodeError: false,
        createRandomCodeMessage: null,
        randomCode: {}
      };
    };
    case actionTypes.CREATE_RANDOM_DISCOUNT_CODE_REJECT: {
      return {
        ...state,
        createRandomCodeLoading: false,
        createRandomCodeFailed: false,
        createRandomCodeError: true,
        createRandomCodeMessage: null,
        randomCode: {}
      };
    };
    case actionTypes.CREATE_RANDOM_DISCOUNT_CODE_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        createRandomCodeLoading: false,
        createRandomCodeFailed: true,
        createRandomCodeError: false,
        createRandomCodeMessage: message,
        randomCode: {}
      };
    };
    case actionTypes.CREATE_RANDOM_DISCOUNT_CODE_SUCCESS: {
      return {
        ...state,
        createRandomCodeLoading: false,
        createRandomCodeFailed: false,
        createRandomCodeError: false,
        createRandomCodeMessage: null,
        randomCode: { ...action.payload }
      };
    };





    case actionTypes.SPECIAL_SEARCHED_USERS_LOADING: {
      return {
        ...state,
        searchedSpecialUsersLoading: true,
        searchedSpecialUsersFailed: false,
        searchedSpecialUsersError: false,
        searchedSpecialUsersMessage: null,
        searchedSpecialUsers: {},
        searchedSpecialUsersList: []
      };
    };
    case actionTypes.SPECIAL_SEARCHED_USERS_REJECT: {
      return {
        ...state,
        searchedSpecialUsersLoading: false,
        searchedSpecialUsersFailed: false,
        searchedSpecialUsersError: true,
        searchedSpecialUsersMessage: null,
        searchedSpecialUsers: {},
        searchedSpecialUsersList: []
      };
    };
    case actionTypes.SPECIAL_SEARCHED_USERS_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        searchedSpecialUsersLoading: false,
        searchedSpecialUsersFailed: true,
        searchedSpecialUsersError: false,
        searchedSpecialUsersMessage: message,
        searchedSpecialUsers: {},
        searchedSpecialUsersList: []
      };
    };
    case actionTypes.SPECIAL_SEARCHED_USERS_SUCCESS: {
      return {
        ...state,
        searchedSpecialUsersLoading: false,
        searchedSpecialUsersFailed: false,
        searchedSpecialUsersError: false,
        searchedSpecialUsersMessage: null,
        searchedSpecialUsers: { ...action.payload },
        searchedSpecialUsersList: [...action.payload.users]
      };
    };







    case actionTypes.DISCOUNT_CODE_USERS_LOADING: {
      return {
        ...state,
        discountCodeUsersLoading: true,
        discountCodeUsersFailed: false,
        discountCodeUsersError: false,
        discountCodeUsersMessage: null,
        discountCodeUsers: {},
        discountCodeUsersList: []
      };
    };
    case actionTypes.DISCOUNT_CODE_USERS_REJECT: {
      return {
        ...state,
        discountCodeUsersLoading: false,
        discountCodeUsersFailed: false,
        discountCodeUsersError: true,
        discountCodeUsersMessage: null,
        discountCodeUsers: {},
        discountCodeUsersList: []
      };
    };
    case actionTypes.DISCOUNT_CODE_USERS_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        discountCodeUsersLoading: false,
        discountCodeUsersFailed: true,
        discountCodeUsersError: false,
        discountCodeUsersMessage: message,
        discountCodeUsers: {},
        discountCodeUsersList: []
      };
    };
    case actionTypes.DISCOUNT_CODE_USERS_SUCCESS: {
      return {
        ...state,
        discountCodeUsersLoading: false,
        discountCodeUsersFailed: false,
        discountCodeUsersError: false,
        discountCodeUsersMessage: null,
        discountCodeUsers: { ...action.payload },
        discountCodeUsersList: [...action.payload.discountCodeUsers]
      };
    };



    default:
      return state;
  }
};
